<template>
  <div>
    <div class="tools-box">
      <!-- type=1 平台单 dockChannel=3 回传的平台单 -->
      <Tooltip v-if="policyDetail.status != 1 && (policyDetail.type == 1 || policyDetail.dockChannel == 3)" transfer content="保单已退保或终止，不能申请保全">
        <Button type="primary" :disabled="true" @click="preservation">申请保全</Button>
      </Tooltip>
      <Button v-else-if="policyDetail.type == 1 || policyDetail.dockChannel == 3" type="primary" @click="preservation">申请保全</Button>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span
            class="table-btn"
            v-if="$units.pointAction('order_50_6') && row.status != '-99'"
            :class="{ 'btn-grey': row.status == '-99' }"
            @click="detail(row)"
            >{{ policyDetail.type != 1 ? '查看人员清单' : '详情' }}</span
          >
          <span v-if="$units.pointAction('order_50_7') && row.billFiles && row.status == '50'" class="table-btn" @click="exportBillFiles(row)">下载批单</span>
          <span
            v-if="($units.pointAction('order_50_8') && row.status == '-15') || row.status == '0' || row.status == '20'"
            class="table-btn"
            @click="reset(row)"
            >撤销</span
          >
        </template>
      </Table>
    </div>

    <Modal
      v-model="personnelVisible"
      title="人员清单"
      :closable="true"
      :mask-closable="false"
      width="1100"
      :footer-hide="true"
      class="my-modal top import-tool-modal2"
    >
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columnsPersonnel" :data="tableDataPersonnel">
          <template slot-scope="{ row }" slot="cardNoMask">
            <div>
              <span v-if="!row.eyeShow1">{{ row.cardNoMask }}</span>
              <span v-else>{{ row.cardNoMask1 }}</span>
              <span v-if="row.cardNoMask">
                <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
              </span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="delPersonnelList(row)">删除</span>
            </div>
          </template>
        </Table>
      </div>
      <Page
        :total="totalPersonnel"
        :current="pageNumPersonnel"
        :page-size="pageSizePersonnel"
        show-total
        @on-change="changePagePersonnel"
        style="text-align: center"
      />
    </Modal>

    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
  </div>
</template>

<script>
import { number_format } from '@/api/filter';

let statusMap = {
  '-20': '批改失败',
  '-15': '核保失败',
  0: '待提交',
  20: '待支付/确认',
  30: '待实收',
  40: '待承保',
  50: '已完成',
  '-99': '已撤销'
};
let typeMap = {
  1: '增保',
  2: '替保',
  3: '减保'
};
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {},
  props: {
    operationFunction: null,
    policyDetail: null
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let createTime = params.row.createTime.substring(0, 16);
            return <span>{createTime}</span>;
          }
        },
        {
          title: '批单ID/批单号',
          key: 'orderNo',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return (
              <div>
                <p>{params.row.businessNo || '-'}</p>
                <p>{params.row.billNo || '-'}</p>
              </div>
            );
          }
        },
        {
          title: '变更类型',
          key: 'type',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {typeMap[params.row.type]}</span>;
          }
        },
        {
          title: '变更内容',
          key: 'createTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let type = params.row.type; // 1-增  2-替 3-减
            if (!type) {
              return <span>-</span>;
            }
            if (type == 1) {
              return <span>{params.row.addCounts ? '加' + params.row.addCounts + '人' : '-'}</span>;
            } else if (type == 2) {
              return (
                <span>
                  加{params.row.addCounts}人，减{params.row.delCounts}人
                </span>
              );
            } else {
              return <span>{params.row.delCounts ? '减' + params.row.delCounts + '人' : '-'}</span>;
            }
          }
        },
        {
          title: '批单生效日期',
          key: 'startTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let startTime = params.row.startTime.substring(0, 10);
            return <span>{startTime}</span>;
          }
        },
        {
          title: '保费',
          key: 'fee',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        },
        {
          title: '服务费',
          key: 'commission',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            if (params.row.commission) {
              return <span> {number_format(params.row.commission, 2)}</span>;
            } else {
              return <span> {number_format(params.row.commission, 2)}</span>;
            }
          }
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {statusMap[params.row.status]}</span>;
          }
        },
        {
          title: '业务员',
          key: 'salemanName',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.staffNo} /{params.row.salemanName}
              </span>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        }
      ],
      personnelVisible: false,
      columnsPersonnel: [
        {
          title: '姓名',
          width: 130,
          key: 'name',
          align: 'center'
        },
        {
          title: '证件号',
          minWidth: 220,
          align: 'center',
          slot: 'cardNoMask'
        },
        {
          title: '保全类型',
          width: 120,
          align: 'center',
          render(h, params) {
            return <span> {typeMap[params.row.endorsementType]}</span>;
          }
        },
        {
          title: '职业类别',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const jobGrade = params.row.jobGrade;
            return <span>{jobGrade ? jobGrade : '-'}</span>;
          }
        },
        {
          title: '保障计划',
          minWidth: 250,
          align: 'center',
          render(h, params) {
            const planName = params.row.planName;
            return <span>{planName ? planName : '-'}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ],
      tableDataPersonnel: [],
      totalPersonnel: 0,
      pageNumPersonnel: 1,
      pageSizePersonnel: 10,
      rowData: {}
    };
  },
  created() {
    this.tableData = [];
    this.initListAjax('/buz/grouppolicy/page/endorsement');
    if (!this.$units.pointAction('order_50_6') && !this.$units.pointAction('order_50_7') && !this.$units.pointAction('order_50_8')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
  },
  methods: {
    openEye(item, keyName, name) {
      if (!item[keyName]) {
        this.descrypt(
          {
            query: item.id,
            operationFunction: this.operationFunction || 19,
            operationType: 1
          },
          item,
          name + '1',
          'order_40_1_3'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    // 转化参数
    setListParams(params) {
      params.policyNo = this.$route.query.policyNo;
    },

    exportBillFiles(row) {
      window.open(row.billFiles);
    },

    reset(row) {
      this.$notice.inquiry('请确认是否要撤销？').then(async () => {
        this.$http({
          url: `/buz/endorsement/cancel`,
          type: 'GET',
          data: {
            businessNo: row.businessNo
          },
          apiPermissionCode: 'order_50_8'
        }).then(res => {
          this.$Message.success('操作成功');
          this.initListAjax('/buz/endorsement/read/list');
        });
      });
    },

    // 详情
    detail(row) {
      if (this.policyDetail.type != 1) {
        this.detailList(row);
      } else {
        this.$http({
          url: `/buz/endorsement/detail?id=${row.id}`,
          type: 'GET',
          apiPermissionCode: 'order_50_6'
        }).then(res => {
          window.open(res.data, '_blank');
        });
      }
    },

    // 获取人员清单
    detailList(row) {
      this.personnelVisible = true;
      this.listLoading = true;
      this.rowData = row;
      this.$http({
        url: '/buz/grouppolicy/page/insures',
        type: 'POST',
        data: {
          pageSize: this.pageSizePersonnel,
          pageNo: this.pageNumPersonnel,
          policyNo: this.rowData.policyNo,
          endorsementId: this.rowData.id
        }
      })
        .then(res => {
          this.tableDataPersonnel = res.data;
          this.totalPersonnel = res.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },

    // 删除人员清单
    delPersonnelList(row) {
      this.$notice.inquiry('请确认是否要删除？').then(async () => {
        this.$http({
          url: `/buz/grouppolicy/enter/insures/delete`,
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$Message.success('删除成功');
          this.detailList(this.rowData);
        });
      });
    },

    // 人员清单分页
    changePagePersonnel(pageNum) {
      this.pageNumPersonnel = pageNum;
      this.detailList(this.rowData);
    },

    // 申请保全
    preservation() {
      this.$http({
        url: `/buz/grouppolicy/preservation`,
        type: 'GET',
        data: { policyNo: this.$route.query.policyNo },
        apiPermissionCode: 'order_50_5'
      }).then(res => {
        res.data && window.open(res.data, '_blank');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

.btn-grey {
  color: #999;
  pointer-events: none;
}
.eye-icon {
  cursor: pointer;
  margin-left: 5px;
}
</style>